var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"vcol vbutton\">\n<button class=\"btn btn-primary btn-sm vparam vybsend\" data-hook=\"sendButton\">SEND</button>\n</div>\n";
},"useData":true});